import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const ArrowLeft = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.645 6.262A.874.874 0 0 0 12.026 6a.861.861 0 0 0-.62.262l-5.249 5.341a.891.891 0 0 0-.257.63.904.904 0 0 0 .257.631l5.25 5.342a.868.868 0 0 0 1.238 0 .9.9 0 0 0 0-1.26l-4.631-4.712 4.631-4.712a.893.893 0 0 0 .258-.63.904.904 0 0 0-.258-.63Z"
      fill={color}
    />
    <Path
      d="M19.644 11.603a.898.898 0 0 1 0 1.26.867.867 0 0 1-.619.26H7.651a.867.867 0 0 1-.618-.26.898.898 0 0 1 0-1.26.867.867 0 0 1 .618-.26h11.374c.232 0 .455.093.619.26Z"
      fill={color}
    />
  </Svg>
);

export default ArrowLeft;
